// Types
import { SummaryTableType } from './SummaryTable.types';

export const summaryTableDataMock: SummaryTableType = {
  summaryTableData: [
    {
      eoyRating: { A: 15, B: 16, C: 11, D: 1, E: 0 },
      typeId: 3,
      type: 'Tanker',
      ytdRating: { A: 12, B: 16, C: 10, D: 4, E: 1 },
      total: 43,
    },
    {
      eoyRating: { A: 2, B: 2, C: 0, D: 0, E: 0 },
      typeId: 1,
      type: 'Gas Carrier',
      ytdRating: { A: 2, B: 1, C: 1, D: 0, E: 0 },
      total: 4,
    },
    {
      eoyRating: { A: 7, B: 3, C: 2, D: 1, E: 2 },
      typeId: 2,
      type: 'Bulk Carrier',
      ytdRating: { A: 10, B: 3, C: 2, D: 0, E: 0 },
      total: 15,
    },
    {
      eoyRating: { A: 2, B: 0, C: 0, D: 1, E: 0 },
      typeId: 4,
      type: 'Cargo Ship',
      ytdRating: { A: 2, B: 0, C: 1, D: 0, E: 0 },
      total: 3,
    },
    {
      eoyRating: { A: 0, B: 1, C: 0, D: 0, E: 0 },
      typeId: 8,
      type: 'LNG Carrier',
      ytdRating: { A: 1, B: 0, C: 0, D: 0, E: 0 },
      total: 1,
    },
  ],
  eoyRatingTotal: { A: 26, B: 22, C: 13, D: 3, E: 2 },
  ytdRatingTotal: { A: 27, B: 20, C: 14, D: 4, E: 1 },
  total: 66,
};
